module.exports = __webpack_public_path__ + "static/media/produtos-newmobile.ae48e40b.jpg";